import { render, staticRenderFns } from "./StatInfo.vue?vue&type=template&id=201812df&scoped=true&"
import script from "./StatInfo.vue?vue&type=script&lang=js&"
export * from "./StatInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201812df",
  null
  
)

export default component.exports